let usersData = [
  {
    name: "Kathryn Murphy2",
    email: "Kn@21",
    account: "(808) ",
    balance: "$149.78",
    branch: "Banyuwangi",
    swiftCode: "78342",
    createdAt: "2022-02-26T16:37:48.244Z"
  },
  {
    name: "Courtney Henry",
    email: "K2@",
    account: "(808) 555-0111 555-0111",
    balance: "$419.78",
    branch: "Karachi",
    swiftCode: "658342",
    createdAt: "1993-02-26T16:37:48.244Z"
  },
  {
    name: "Eleanor Pena",
    email: "Kty@n21",
    account: "(808) 555-0111",
    balance: "$687.78",
    branch: "ber",
    swiftCode: "18342",
    createdAt: "1893-02-26T20:37:48.244Z"
  },
  {
    name: "Floyd Miles",
    email: "Kaa@yn21",
    account: "(808) 555-0111",
    balance: "$2109.78",
    branch: "Jem",
    swiftCode: "31342",
    createdAt: "2022-12-26T16:37:48.244Z"
  },
  {
    name: "Henry",
    email: "hty@n21",
    account: "(808) 543-0111",
    balance: "$2989.78",
    branch: "Jember",
    swiftCode: "68542",
    createdAt: "2021-02-26T16:37:48.244Z"
  },
  {
    name: " ATX",
    email: "Ken@asd01",
    account: "(808) 555-0111",
    balance: "$19.78",
    branch: "Lahore",
    swiftCode: "78342",
    createdAt: "2022-08-26T16:37:48.244Z"
  },
  {
    name: "XSD5",
    email: "XeD@1.com",
    account: "(808) 555-0111",
    balance: "$19.00",
    branch: "Azad kashmir",
    swiftCode: "658342",
    createdAt: "2022-02-20T16:37:48.244Z"
  },
  {
    name: "ATX",
    email: "Knn@ad21",
    account: "(808) 555-0111",
    balance: "$39.78",
    branch: "Lahore",
    swiftCode: "78342",
    createdAt: "2021-11-26T16:37:48.244Z"
  },
  {
    name: " XSD",
    email: "Kq1@",
    account: "(808) 555-0111",
    balance: "$74.78",
    branch: "Karachi",
    swiftCode: "658342",
    createdAt: "2002-02-26T16:37:48.244Z"
  },
  {
    name: " Adf",
    email: "nqa@sd21",
    account: "(808) 555-0111",
    balance: "$89.78",
    branch: "Lahore",
    swiftCode: "78342",
    createdAt: "2013-04-26T16:37:48.244Z"
  },
  {
    name: " XSD2",
    email: "af@1",
    account: "(808) 555-0111",
    balance: "$88.78",
    branch: "Lahore",
    swiftCode: "658342",
    createdAt: "2022-09-26T16:37:48.244Z"
  },
  {
    name: "AWE",
    email: "Kn@asd201",
    account: "(808) 555-0111",
    balance: "$769.78",
    branch: "Lahore",
    swiftCode: "78342",
    createdAt: "2022-02-01T16:37:48.244Z"
  },
  {
    name: "XSD3",
    email: "bf@1",
    account: "(808) 555-0111",
    balance: "$69.78",
    branch: "Sukkur",
    swiftCode: "658342",
    createdAt: "2020-02-02T16:37:48.244Z"
  },
  {
    name: "AWEWTR",
    email: "za@d21",
    account: "(808) 555-0111",
    balance: "$96.78",
    branch: "Lahore",
    swiftCode: "78342",
    createdAt: "2022-03-16T16:37:48.244Z"
  },
  {
    name: "XSD",
    email: "cf@1",
    account: "(808) 555-0111",
    balance: "$321.78",
    branch: "zyarat",
    swiftCode: "658342",
    createdAt: "2022-04-24T16:37:48.244Z"
  },
  {
    name: " AM",
    email: "KD@21",
    account: "(808) 555-0111",
    balance: "$299.78",
    branch: "Lahore",
    swiftCode: "78342",
    createdAt: "2021-08-26T16:37:48.244Z"
  },
  {
    name: " XSD9",
    email: "df@1",
    account: "(808) 555-0111",
    balance: "$999.78",
    branch: "Karachi",
    swiftCode: "658342",
    createdAt: "1090-02-26T16:37:48.244Z"
  },
  {
    name: " MP",
    email: "MP@1",
    account: "(808) 555-0111",
    balance: "$219.78",
    branch: "Lahore",
    swiftCode: "78342",
    createdAt: "2021-07-26T16:37:48.244Z"
  },
  {
    name: " XSD10",
    email: "K2@1",
    account: "(808) 555-0111",
    balance: "$209.78",
    branch: "Khuzdar",
    swiftCode: "658342",
    createdAt: "2013-05-26T10:37:48.244Z"
  },

  {
    name: "Kathryn Murphy1",
    email: "Ka@trhyn21",
    account: "(546) 245-0111",
    balance: "$333.78",
    branch: "Surabaya",
    swiftCode: "68422",
    createdAt: "2022-11-26T21:37:48.244Z"
  },
  {
    name: " TU",
    email: "Kn@asd21",
    account: "(808) 555-0111",
    balance: "$919.78",
    branch: "Lahore",
    swiftCode: "78342",
    createdAt: "2022-02-26T18:37:48.244Z"
  },
  {
    name: "XSD19",
    email: "Kd@f1",
    account: "(808) 555-0111",
    balance: "$421.78",
    branch: "Islam Abad",
    swiftCode: "658342",
    createdAt: "2022-02-26T26:37:48.244Z"
  },

  {
    name: "Kathryn Murphy",
    email: "Ka@zyn21",
    account: "(546) 555-0111",
    balance: "$29.78",
    branch: "Zone",
    swiftCode: "63842",
    createdAt: "2022-11-26T01:37:48.244Z"
  },
];
 usersData = usersData.sort((a,b) => new Date(b.createdAt) - new Date(a.createdAt)).reverse();
 
 console.log(usersData);
 export {usersData};